import {Button, Grid, Typography} from "@material-ui/core";
import InlineRadioButtons from "../../../../../../ui/inputs/radio-buttons/inline-radio-buttons/InlineRadioButtons";
import PropTypes from "prop-types";
import {apnTypeEnum, disableConfirmBtn} from "./InitialStepHelper";
import DefaultSelect from "../../../../../../ui/inputs/selects/default-select/DefaultSelect";

const InitialDialogContent = (props) => {
    const showInputVrf = props.changeApnForm.apnType === apnTypeEnum.CONDIVISO
    const isSicurezza = props.changeApnForm.apnType === apnTypeEnum.SICUREZZA_CENTRALIZZATA
    const showInputForm = props.changeApnForm.apnType !== apnTypeEnum.PUBBLICO
        && props.changeApnForm.apnType

    // Take the apn options without the one that the SIM now has
    const validApnOptions = props.apnOptions.filter(option => !props.currentApn.includes(option.text))

    return (
        <>
            <Typography variant="subtitle2">
                Stai chiedendo la modifica della tipologia di APN. <br/>
                Scegli quale vuoi che sia il nuovo tipo di APN su questa SIM.
            </Typography>

            <InlineRadioButtons value={props.changeApnForm.apnType}
                                radioButtons={validApnOptions}
                                handleChange={(e) => props.handleChangeApnForm(e, "apnType")}/>

            {showInputForm ?
                <Grid container
                      spacing={3}
                      alignItems="center"
                      justifyContent="center">
                    <Grid item
                          xs={12} sm={4} md={3}>
                        <Typography variant="subtitle2">Nome APN</Typography>
                    </Grid>

                    <Grid item
                          xs={12} sm={8} md={9}>
                        <DefaultSelect
                            value={props.changeApnForm.apnName}
                            handleOnChange={(e) => props.handleChangeApnForm(e, "apnName")}
                            fullWidth
                            label="Scegli fra i nomi APN attivi"
                            menuItems={showInputVrf ?
                                props.selectValues.condivisoApnNames : isSicurezza ?
                                    props.selectValues.sicurezzaCentralizzataApnNames
                                    : props.selectValues.dedicatoApnNames
                            }
                            hasEmptyItem={true}/>
                    </Grid>

                    {showInputVrf ?
                        <>
                            <Grid item
                                  xs={12} sm={4} md={3}>
                                <Typography variant="subtitle2">Nome VRF</Typography>
                            </Grid>

                            <Grid item
                                  xs={12} sm={8} md={9}>
                                <DefaultSelect value={props.changeApnForm.vrfName}
                                               handleOnChange={(e) => props.handleChangeApnForm(e, "vrfName")}
                                               fullWidth
                                               label="Scegli fra i VRF attivi"
                                               menuItems={props.selectValues.condivisoVrfNames}
                                               hasEmptyItem={true}/>
                            </Grid>
                        </> : null}
                </Grid> : null}
        </>
    )
}

InitialDialogContent.propTypes = {
    changeApnForm: PropTypes.shape({
        apnType: PropTypes.string.isRequired,
        apnName: PropTypes.string.isRequired,
        vrfName: PropTypes.string.isRequired
    }).isRequired,
    apnOptions: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
    })).isRequired,
    selectValues: PropTypes.shape({
        condivisoApnNames: PropTypes.arrayOf(PropTypes.shape({
            value: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
        })).isRequired,
        condivisoVrfNames: PropTypes.arrayOf(PropTypes.shape({
            value: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
        })).isRequired,
        dedicatoApnNames: PropTypes.arrayOf(PropTypes.shape({
            value: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
        })).isRequired,
    }).isRequired,
    currentApn: PropTypes.string.isRequired,
    handleChangeApnForm: PropTypes.func.isRequired
}

const InitialDialogActions = (props) => {
    return (
        <Grid container
              justifyContent="space-between">
            <Button variant="outlined"
                    color="primary"
                    onClick={props.handleClose}>
                Annulla
            </Button>

            <Button variant="contained"
                    color="primary"
                    disabled={disableConfirmBtn(props.changeApnForm)}
                    onClick={props.moveToNextStep}>
                Conferma
            </Button>
        </Grid>
    )
}

InitialDialogActions.propTypes = {
    changeApnForm: PropTypes.shape({
        apnType: PropTypes.string.isRequired,
        apnName: PropTypes.string.isRequired,
        vrfName: PropTypes.string.isRequired
    }).isRequired,
    moveToNextStep: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired
}

export {InitialDialogActions, InitialDialogContent}
